import { XMarkIcon } from "@heroicons/react/24/outline";
import { AspectRatio, Box, IconButton, Modal } from "@mui/joy";
import { useEffect, useState } from "react";
import { theme } from "../../Theme";
import VideoPlayer from "../../VideoPlayer";

type Props = {
  imageSrc: string;
  show: boolean;
  onClose: () => void;
  type?: string;
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const ImageFullScreenView = ({
  imageSrc,
  show,
  onClose,
  type = "image",
}: Props) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  const handleClose = () => {
    setShowModal(false);
    onClose();
  };

  return (
    <Modal
      open={showModal}
      style={{
        backgroundColor: "#32383E99",
        backdropFilter: "unset",
      }}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} justifyContent={"center"}>
        {type === "video" ? (
          <VideoPlayer
            width={{ xs: "357px", md: "500px" }}
            height={{ xs: "357px", md: "500px" }}
            videoSrc={imageSrc}
          />
        ) : (
          <AspectRatio
            ratio="1"
            variant={"soft"}
            sx={{
              width: { xs: "357px", md: "500px" },
              height: { xs: "357px", md: "500px" },
              borderRadius: "8px",
            }}
          >
            <img
              alt={imageSrc}
              src={imageSrc}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
          </AspectRatio>
        )}

        {/* exit button */}
        <IconButton
          sx={{
            position: "absolute",
            backgroundColor: "transparent",
            top: { xs: "72px", md: "8px" },
            right: "8px",
            p: "10px",
            ...(type === "video"
              ? {
                  border: `1px solid ${theme.palette.common.white}`,
                  color: theme.palette.common.white,
                }
              : {
                  border: `1px solid ${theme.palette.primary[400]}`,
                  color: theme.palette.primary[400],
                }),
          }}
          onClick={handleClose}
        >
          <XMarkIcon width={"18px"} height={"18px"} />
        </IconButton>
      </Box>
    </Modal>
  );
};

export default ImageFullScreenView;
